// extracted by mini-css-extract-plugin
export default {"form":"SmsModal2_form__WyuVT","errorBanner":"SmsModal2_errorBanner__WWW6n","errorText":"SmsModal2_errorText__47cCT","footer":"SmsModal2_footer__Z4x48"};